import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { finalize, take } from 'rxjs/operators';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ActionSheetController } from '@ionic/angular';

import { LoginService } from 'src/app/services/login/login.service';

import { LoginCredential } from 'src/app/models/login/login-credential';
import { UserService } from 'src/app/services/user/user.service';
import { SettingService } from 'src/app/services/settings/settings.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { NotificationAlertService } from '@services/index';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    readonly ACTION_RECAPTCHA = 'actionLoginStaff';
    recaptchaVersion = 'version=V3';

    currentYear = new Date().getFullYear();
    isLoading = false;
    showModal = false;
    ifUserLogged = true;
    typePassword = 'password';
    isVisiblePassword = false;
    credentials: LoginCredential = { nickname: '', password: '' };

    constructor(private readonly loginService: LoginService,
                private readonly userService: UserService,
                private readonly translateService: TranslateService,
                private readonly recaptchaV3Service: ReCaptchaV3Service,
                private readonly actionSheetCtrl: ActionSheetController,
                private readonly router: Router,
                private readonly settingService: SettingService,
                private readonly loadingservice: LoadingService,
                private readonly notificationAlertService: NotificationAlertService) { }

    ngOnInit(): void {
        this.ifUserLogged = this.loginService.isLoggedIn();
        if (this.ifUserLogged) {
            void this.router.navigate(['/schedule']);
        }
    }

    submit(): void {
        this.isLoading = true;
        this.loadingservice.setLoading(this.isLoading);

        this.recaptchaV3Service.execute(this.ACTION_RECAPTCHA)
            .pipe(take(1))
            .subscribe((token) => {
                this.login(this.credentials, token);
                this.isLoading = false;
                this.loadingservice.setLoading(false);
            });
    }

    setNickname(event: string): void {
        this.credentials.nickname = event;
    }

    goToRecovery(): void {
        void this.router.navigate(['/recover']);
    }

    private login(loginCredential: LoginCredential, recaptcha: string): void {
        // TODO: ¿RecaptchaV2?
        this.isLoading = true;
        this.loadingservice.setLoading(this.isLoading);
        this.loginService.login(loginCredential, 'es_ES', `${recaptcha}&${this.recaptchaVersion}`, '').pipe(finalize(() => this.isLoading = false)).subscribe({
            next: res => {
                void this.loginSuccess(res);
            },
            error: () => {
                this.notificationAlertService.addErrorMessage('incorrect_credentials_info');
            }
        });
    }

    private async loginSuccess(res: any): Promise<void> {
        this.userService.setToken(res.token);
        this.userService.setActiveToken();
        this.userService.setUser(res.idUser);
        this.userService.setIdStaff(res.idUser);
        if (res.centers.length > 1) {
            const actionSheet = await this.actionSheetCtrl.create({
                header: this.translateService.instant('select_center'),
                buttons: res.centers.map((c: any) => ({ text: c.name, data: c }))
            });

            await actionSheet.present();
            const result = await actionSheet.onDidDismiss();

            this.setCenterAndNavigate(result.data);
        } else if (res.centers.length) {
            this.setCenterAndNavigate(res.centers[0]);
        }
        this.isLoading = false;
    }

    togglePassword(): void {
        this.isVisiblePassword = !this.isVisiblePassword;
        if (this.isVisiblePassword) {
            this.typePassword = 'text';
        } else {
            this.typePassword = 'password';
        }
    }

    private setCenterAndNavigate(center: any): void {
        this.userService.setCenter(center);
        this.settingService.getConfiguration().subscribe(
            () => {
                this.isLoading = false;
                const isTemporalPassword = this.userService.getStaffData()?.isTemporalPassword;
                if (!isTemporalPassword) {
                    void this.router.navigate(['/schedule']);
                } else {
                    void this.router.navigate(['/credentials']);
                }
            }
        );
    }
}
